module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splashScreen",
    class: _vm.delayClasses
  }, [_c('div', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": "static/logo.png"
    }
  }), _c('p', [(_vm.isInitialized && _vm.isConnected) ? [_vm._v(_vm._s(_vm.$t('home.groupsLoading')))] : [_vm._v(_vm._s(_vm.$t('globals.loading')))]], 2), _c('i', {
    staticClass: "fa fa-spin fa-refresh"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-235a11a0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SplashScreen.vue
// module id = 874
// module chunks = 13